import React, { useEffect } from 'react'

const useOutsideClick = (ref: React.RefObject<HTMLElement>, callback: () => void) => {
    useEffect(() => {
        const handleClick = (e: MouseEvent) => {
            const target = e.target as HTMLElement
            const isInsideDialog = target.closest('.MuiDialog-container, .MuiDialog-paper')
            if (isInsideDialog) return
            const portalSelectors = [
                '.MuiPopover-root',
                '.MuiMenu-root',
                '.MuiAutocomplete-popper',
                '.MuiDatePickerPopper',
                '[role="tooltip"]',
                '.ColorPicker-MuiPopover-paper',
                '.ColorPicker-MuiPopover-root'
            ]
            for (const selector of portalSelectors) {
                const portalEl = document.querySelector(selector)
                if (portalEl?.contains(target)) return
            }
            if (ref.current && !ref.current.contains(e.target as Node)) {
                callback()
            }
        }

        document.addEventListener('mousedown', handleClick)

        return () => {
            document.removeEventListener('mousedown', handleClick)
        }
    }, [ref, callback])
}

export default useOutsideClick
